
// import router from '@/router/index'

import zoneService from '@/api/zoneService'
import kendo from "@progress/kendo-ui";

const state = {


    zones: [],
    Dropzones: [],
    newZone: {},
    edit: false
}
const getters = {

    zoneMngt: state => state.zones,
    Dropzones: state => state.Dropzones,

    newZone: state => state.newZone,
    edit: state => state.edit

};

const actions = {
    async getnewZone({ commit }) {
        const res = await zoneService.getZone()

        commit('get', res.data.result)
    },
    async addZone({ commit }, zone) {

        await zoneService.addZone(zone)

        commit('add', zone)

    },
    editZone({ commit }, zone) {
        commit('update', zone)
    },
    async updateZone({ commit }, zone) {
        await zoneService.updateZone(zone.id, zone.Data)
        commit('update', zone)


    },
    async removeZone({ commit }, zone) {
        await zoneService.removeZone(zone)
        commit('remove', zone)
    },


}
const mutations = {
    get(state, zone) {

        let data = new kendo.data.HierarchicalDataSource({
            data: zone,
            schema: {
                model: {
                    id: 'id',
                    children: "subZone"
                }
            }
        });
        let dropZone = zone
        dropZone.unshift({ name: "NONE", id: 0 })
        let Dropdata = new kendo.data.HierarchicalDataSource({
            data: dropZone,
            schema: {
                model: {
                    id: 'id',
                    children: "subZone"
                }
            }
        });
        state.zones = data
        state.Dropzones = Dropdata
        // console.log("dataaaaa", state.zones)

    },
    add() {
        // console.log("zone", zone)

    },

    edit(state, zone) {
        state.editId = zone.id
        state.edit = true
    },
    update() {

    },
    remove() {

    },
    cancel(state) {
        state.newFeature = {}
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}